import React from 'react';
import { Dialog } from '../../../../Components/MUIs';
import './LEG_BASIC_LawSelectDialog.styles.css';

/** 법규준수평가 — 이미 저장된 점검표 안내 팝업 */
function LEG_BASIC_ExistingEvalDialog({
  open = false,
  lawNm = '',
  onClose = () => {},
  onConfirm = () => {},
}) {
  const name = String(lawNm ?? '').trim();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="이미 저장된 점검표"
      maxWidth="sm"
      fullWidth
      useSaveButton={true}
      useCloseButton={true}
      saveButtonName="확인"
      closeButtonName="닫기"
      onSave={onConfirm}
      titleSx={{ pb: 1, fontWeight: 700, fontSize: 18 }}
      contentSx={{ pt: 4, px: 2.5, pb: 2.5 }}
      content={
        <div className="leg-law-select">
          <div className="leg-law-select__intro leg-law-select__intro--notice">
            <div className="leg-law-select__intro-icon leg-law-select__intro-icon--notice">
              <span className="material-symbols-outlined">info</span>
            </div>
            <div>
              <div className="leg-law-select__intro-title">
                기본정보에 이미 등록된 점검표입니다
              </div>
              <p className="leg-law-select__intro-desc">
                이미 저장된 평가는 원칙적으로 수정할 수 없습니다. 조회는
                기본정보 목록에서 해당 행을 열어 확인하시고, 삭제도 목록에서만
                가능합니다.
              </p>
            </div>
          </div>

          {name ? (
            <div className="leg-law-select__card leg-law-select__card--custom leg-law-select__card--static">
              <div className="leg-law-select__card-main">
                <div className="leg-law-select__card-icon">
                  <span className="material-symbols-outlined">menu_book</span>
                </div>
                <div className="leg-law-select__card-body">
                  <div className="leg-law-select__card-top">
                    <span className="leg-law-select__card-title">{name}</span>
                    <span className="leg-law-select__badge leg-law-select__badge--saved">
                      저장됨
                    </span>
                  </div>
                  <p className="leg-law-select__card-desc">
                    기본정보 목록에서 이 법령 점검표를 열어 조회할 수 있습니다.
                    수정은 불가하며, 삭제는 목록에서만 가능합니다.
                  </p>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      }
    />
  );
}

export default LEG_BASIC_ExistingEvalDialog;
